/* eslint-disable prefer-const */
/* eslint-disable default-case */
/* eslint-disable no-undef */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-expressions */
import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import {
  Typography, Box, Grid, Container, Divider,
} from '@mui/material';
import { useTranslation } from 'next-i18next';
import { useDispatch } from 'react-redux';
import Head from 'next/head';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { defaultNS } from 'next-i18next.config';
import Breadcrumbs from 'views/common/components/UI/Breadcrumbs';
import ERPagination from 'views/common/components/UI/ERPagination';
import NavigatorLink from 'views/common/components/Logical/NavigatorLink';
import useAppNavigator from 'views/rebranded-module/common/hooks/useAppNavigator';
import axios, { API } from 'lib/config/axios';
import PATHS from 'lib/navigation/paths';
import { serverFetch } from 'lib/utils/serverFetch';
import generateHreflang from 'lib/utils/generateHreflang';
import generateMetaData from 'lib/utils/generateMetaData';
import { setLoading } from 'redux/features/ui-slice';
import { mapNamedLocaleToLocale } from 'lib/data/localesMap';

import useErrorsHandler from 'views/rebranded-module/common/hooks/useErrorsHandler';
import getLocalizedUrl from 'lib/utils/getLocalizedUrl';

const PREFIX = 'Siteindex';

const classes = {
  destinationContainer: `${PREFIX}-destinationContainer`,
  pageTitle: `${PREFIX}-pageTitle`,
  sectionTitle: `${PREFIX}-sectionTitle`,
  destinationsRow: `${PREFIX}-destinationsRow`,
  destinationLink: `${PREFIX}-destinationLink`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.destinationContainer}`]: {
    backgroundColor: theme.palette.common.white,
    paddingBottom: 46,
  },

  [`& .${classes.pageTitle}`]: {
    fontSize: theme.typography.pxToRem(28),
    color: theme.palette.grey[900],
    padding: `${theme.typography.pxToRem(64)} 0`,
  },

  [`& .${classes.sectionTitle}`]: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 500,
    color: theme.palette.grey[700],
    marginBottom: theme.typography.pxToRem(10),
  },

  [`& .${classes.destinationsRow}`]: {
    display: 'flex',
  },

  [`& .${classes.destinationLink}`]: {
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.primary.main,
    textDecoration: 'underline',
    display: 'block',
    marginBottom: theme.spacing(1),
  },
}));

const Siteindex = (props) => {
  const { renderErrorPage, pageData } = props;
  const { t } = useTranslation('fe_er_siteindex');
  const appNavigator = useAppNavigator();
  const dispatch = useDispatch();
  const handleErrorResponse = useErrorsHandler();
  const [data, setData] = useState(pageData);

  if (renderErrorPage) {
    handleErrorResponse({}, false);
  }

  const createBreadCrumbProps = () => {
    const breadCrumbLinks = [];

    breadCrumbLinks.push({
      text: t('fe_er_siteindex:sitemap_index'),
      path: data.routes.site_index_path,
    });
    data.current_place
      && (data.country
        && breadCrumbLinks.push({
          text: data.country.name,
          path: `${data.routes.site_index_path}/${data.country.slug}`,
        }),
      data.region
        && breadCrumbLinks.push({
          text: data.region.name,
          path: `${data.routes.site_index_path}/${data.region.slug}`,
        }),
      !(
        data.current_place.type == 'region'
        || data.current_place.type == 'country'
      )
        && breadCrumbLinks.push({
          text: data.current_place.name,
          path: `${data.routes.site_index_path}/${data.current_place.slug}`,
        }));

    const compactLinks = breadCrumbLinks.filter((link) => link != null);
    const pageTitle = compactLinks.slice(-1)[0];

    const breadCrumbsProps = {
      links: compactLinks.slice(0, -1),
      breadCrumbsTitle: pageTitle ? pageTitle.text : '',
    };

    return breadCrumbsProps;
  };

  function chunkArray(myArray, chunk_size) {
    let index = 0;
    const arrayLength = myArray.length;
    const tempArray = [];
    for (index = 0; index < arrayLength; index += chunk_size) {
      const myChunk = myArray.slice(index, index + chunk_size);
      tempArray.push(myChunk);
    }
    return tempArray;
  }

  const generateMakeTypesLinks = (arr) => {
    const links = arr.map((obj, index) => {
      let path;
      if (data.current_place) {
        path = data.routes.vehicle_make_or_type_and_place_path
          .replace('$vehicle_make_or_type', obj.slug)
          .replace('$place', data.current_place.slug);
      } else {
        path = data.routes.vehicle_make_or_type_path.replace(
          '$vehicle_make_or_type',
          obj.slug,
        );
      }

      obj.path = path;
      return obj;
    });

    const chunkedArr = chunkArray(links, Math.ceil(arr.length / 3));
    return chunkedArr;
  };

  const generateDestinationsLinks = () => {
    const links = data.places.map((obj, index) => {
      let path;
      path = data.routes.place_site_index_path.replace('$place', obj.slug);

      obj.path = path;
      return obj;
    });
    const chunkedArr = chunkArray(links, Math.ceil(data.places.length / 3));
    return chunkedArr;
  };

  const sectionCreator = (header, links, type_make) => (
    <Box mb={6}>
      <Typography className={classes.sectionTitle}>{header.text}</Typography>
      <Grid container spacing={1} className={classes.destinationsRow}>
        {links.map((chunk, index) => (
          <Grid item xs={12} md={6} lg={4} key={index}>
            {chunk.map((link, index) => (
              <NavigatorLink
                href={link.path}
                className={classes.destinationLink}
                key={`${link.slug}${index}`}>
                {type_make
                  ? data.current_place
                    ? `${link.name} ${t('fe_er_siteindex:rentals')} ${t(
                      'fe_er_siteindex:in',
                    )} ${data.current_place.name}`
                    : `${link.name} ${t('fe_er_siteindex:rentals')}`
                  : link.name}
              </NavigatorLink>
            ))}
          </Grid>
        ))}
      </Grid>
    </Box>
  );

  const handlePageChange = (page) => {
    dispatch(setLoading(true));
    let apiLink;
    if (Object.keys(appNavigator.query).length === 0) {
      apiLink = API.siteIndex.siteIndex;
    } else if (appNavigator.query.place) {
      apiLink = API.siteIndex.filteredSiteIndex.replace(
        '{place}',
        appNavigator.query.place,
      );
    }
    (async () => {
      try {
        const result = await axios.get(apiLink, {
          params: {
            page,
          },
        });
        setData(result.data);
      } catch (err) {
        switch (err.response.status) {
          case 400:
            if (err.response.data) {
              dispatch(setLoading(true));
              let redirectLink;
              if (appNavigator.query.subpath) {
                redirectLink = `${
                  appNavigator.query.subpath
                }${API.siteIndex.filteredSiteIndex.replace(
                  '{place}',
                  err.response.data.new_slug,
                )}`;
              } else {
                redirectLink = `${API.siteIndex.filteredSiteIndex.replace(
                  '{place}',
                  err.response.data.new_slug,
                )}`;
              }
              appNavigator.push({
                url: redirectLink,
                query: { page },
              });
            }
            break;
          case 404:
            // eslint-disable-next-line no-const-assign
            pageData = err.response.status;
            res.statusCode = 503;
            res.end();
            break;
          default:
            handleErrorResponse(err);
        }
      }
    })();
  };

  React.useEffect(() => {
    dispatch(setLoading(false));
  }, [data]);

  if (!data) return null;
  return (
    <Root>
      <Head>{data.meta_data && generateMetaData(data.meta_data)}</Head>
      <Box className={classes.destinationContainer}>
        <Container maxWidth="xl">
          <Breadcrumbs data={createBreadCrumbProps()} />
          <Divider light />
          <Typography className={classes.pageTitle}>
            {`${data.current_place ? data.current_place.name : ''} ${t(
              'fe_er_siteindex:sitemap',
            )}`}
          </Typography>
          {data.vehicle_types.length
            ? sectionCreator(
              {
                text: data.current_place
                  ? `${t('fe_er_siteindex:all_rentals')} ${t(
                    'fe_er_siteindex:types',
                  )} ${t('fe_er_siteindex:in')} ${data.current_place.name}`
                  : `${t('fe_er_siteindex:all_rentals')} ${t(
                    'fe_er_siteindex:types',
                  )}`,
              },
              generateMakeTypesLinks(data.vehicle_types),
              'type_make',
            )
            : null}
          {/* makes */}
          {data.vehicle_makes.length
            ? sectionCreator(
              {
                text: data.current_place
                  ? `${t('fe_er_siteindex:all_rentals')} ${t(
                    'fe_er_siteindex:makes',
                  )} ${t('fe_er_siteindex:in')} ${data.current_place.name}`
                  : `${t('fe_er_siteindex:all_rentals')} ${t(
                    'fe_er_siteindex:makes',
                  )}`,
              },
              generateMakeTypesLinks(data.vehicle_makes),
              'type_make',
            )
            : null}
          {/* Destinations */}
          {data.places.length
            ? sectionCreator(
              {
                text: t('fe_er_siteindex:destinations'),
              },
              generateDestinationsLinks(),
            )
            : null}
          {data.current_place && data.pagination.pages_count > 1 && (
            <ERPagination
              data={data.pagination}
              url={`${appNavigator.pathname}/${appNavigator.query.place}`}
              handleChange={(page) => handlePageChange(page)}
              link
            />
          )}
        </Container>
      </Box>
    </Root>
  );
};
export async function getServerSideProps(ctx) {
  const { res, locale } = ctx;

  // generate canonical and hrefLang
  let apiLink = '';
  let hreflangData = null;
  hreflangData = generateHreflang(
    ctx.query.place
      ? PATHS.siteIndexPlace(ctx.query.place).url
      : PATHS.siteIndex().url,
    locale,
  );

  const params = { ...ctx.query };
  delete params.id;
  let layoutData = null;

  {
    const { success, data } = await serverFetch(ctx, API.layout, params);
    if (success && data) layoutData = data;
    else {
      ctx.res.statusCode = 500;
      throw new Error('Rendering halted because we failed to load layout data');
    }
  }
  if (ctx.query.place) {
    apiLink = API.siteIndex.filteredSiteIndex.replace(
      '{place}',
      ctx.query.place,
    );
  } else {
    apiLink = API.siteIndex.siteIndex;
  }

  let pageData = null;
  let renderErrorPage = false;

  const { success, data, error } = await serverFetch(ctx, apiLink, {
    page: ctx.query.page || 1,
  });

  if (success && data) pageData = data;
  else {
    switch (error.response?.status) {
      case 400:
        if (error.response.data) {
          const redirectLink = ctx.query.page
            ? `${API.siteIndex.filteredSiteIndex
              .replace('{place}', error.response.data.new_slug)
              .replace('{page}', ctx.query.page)}`
            : `${API.siteIndex.filteredSiteIndex.replace(
              '{place}',
              error.response.data.new_slug,
            )}`;
          return {
            redirect: {
              destination: encodeURI(getLocalizedUrl(redirectLink, locale)),
              permanent: true,
            },
          };
        }
        break;
      case 404:
        pageData = error.response.status;
        res.statusCode = 503;
        res.end();
        break;
      default:
        res.statusCode = error.response?.status || 404;
        renderErrorPage = true;
    }
  }
  return {
    props: {
      ...(await serverSideTranslations(mapNamedLocaleToLocale[locale], [
        ...defaultNS,
        'fe_er_pagination',
        'fe_er_siteindex',
      ])),
      pageData,
      hreflangData,
      layoutData,
      renderErrorPage,
    },
  };
}

export default Siteindex;
